<script setup lang="ts">
defineProps<{ title: string; subtitle?: string; actionLabel?: string }>()
defineEmits<{ (e: 'action'): void }>()
</script>
<template>
  <section class="rounded-2xl border border-slate-700/50 bg-slate-800/50 p-4 shadow-xl shadow-black/5 backdrop-blur-xl transition hover:border-emerald-500/20 sm:p-5">
    <header class="mb-4 flex items-start justify-between gap-3 border-b border-slate-700/40 pb-4">
      <div><h2 class="text-base font-extrabold text-white">{{ title }}</h2><p v-if="subtitle" class="mt-1 text-xs text-slate-500">{{ subtitle }}</p></div>
      <button v-if="actionLabel" class="shrink-0 text-xs font-bold text-emerald-400 hover:text-emerald-300" @click="$emit('action')">{{ actionLabel }}</button>
    </header>
    <slot />
  </section>
</template>
